export default "__VITE_ASSET__DmXAerl7__"